(function () {
  const initTabbedContent = (section) => {
    const root =
      section ||
      document.querySelector(".tabbed-content-split[data-section-id]");
    if (!root) return;

    const sectionId = root.dataset.sectionId;
    const tabs = root.querySelectorAll(".tabbed-content-split__tab");
    const contentEl = root.querySelector(`#tabbed-content-${sectionId}`);

    if (!tabs.length || !contentEl) return;

    const DURATION = 300;
    const imageId = `tabbed-content-image-${sectionId}`;

    const handleTabActivate = (tab) => {
      if (!tab || tab.classList.contains("is-active")) return;

        const imageEl = root.querySelector(`#${imageId}`);
        const imagewrap = imageEl ? imageEl.closest(".tabbed-content-split__imagewrap") : null;

        tabs.forEach((t) => t.classList.remove("is-active"));
        tab.classList.add("is-active");

        const tabKey = tab.dataset.tabKey;
        const dataScript = root.querySelector(
          `.tabbed-content-data[data-tab-id="${tabKey}"]`
        );
        let headingHtml = null;
        let buttonLabel = null;
        let buttonLink = null;
        let imageUrl = null;

        if (dataScript) {
          try {
            const data = JSON.parse(dataScript.textContent);
            headingHtml = data.heading;
            buttonLabel = data.buttonLabel;
            buttonLink = data.buttonLink;
            imageUrl = data.imageUrl;
          } catch (e) {
            console.warn("Failed to parse tab data:", e);
          }
        }

        contentEl.classList.add("is-transitioning");
        if (imagewrap && imageUrl && imageEl) imagewrap.classList.add("is-transitioning");

        const swapContent = () => {
          contentEl.innerHTML = "";

          if (headingHtml) {
            const headingTag =
              root
                .querySelector(".tabbed-content-split__heading")
                ?.tagName.toLowerCase() || "h3";
            const headingWrapper = document.createElement(headingTag);
            headingWrapper.className = "tabbed-content-split__heading richtext__content";
            headingWrapper.innerHTML = headingHtml;
            contentEl.appendChild(headingWrapper);
          }

          if (buttonLabel && buttonLink) {
            const button = document.createElement("a");
            button.href = buttonLink;
            button.className = "tabbed-content-split__btn";
            button.textContent = buttonLabel;
            contentEl.appendChild(button);
          }

          contentEl.classList.remove("is-transitioning");
        };

        if (imagewrap && imageUrl && imageEl) {
          const newImg = new Image();
          newImg.alt = "Tabbed content image";
          newImg.className = "tabbed-content-split__img";
          newImg.style.cssText =
            "position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:20% 30%;opacity:0;transition:opacity 0.3s ease;";
          newImg.src = imageUrl;
          newImg.srcset =
            imageUrl.replace("width=1400", "width=400") +
            " 400w, " +
            imageUrl.replace("width=1400", "width=600") +
            " 600w, " +
            imageUrl.replace("width=1400", "width=800") +
            " 800w, " +
            imageUrl.replace("width=1400", "width=1000") +
            " 1000w, " +
            imageUrl.replace("width=1400", "width=1200") +
            " 1200w, " +
            imageUrl +
            " 1400w";

          const finishImageTransition = () => {
            if (imageEl.parentNode) imageEl.parentNode.removeChild(imageEl);
            newImg.removeAttribute("style");
            newImg.id = imageId;
            imagewrap.classList.remove("is-transitioning");
          };

          newImg.onload = () => {
            swapContent();
            imagewrap.appendChild(newImg);
            newImg.offsetHeight;
            newImg.style.opacity = "1";
            setTimeout(finishImageTransition, DURATION);
          };
          newImg.onerror = () => {
            imagewrap.classList.remove("is-transitioning");
            requestAnimationFrame(() => setTimeout(swapContent, 0));
          };
        } else {
          if (imagewrap) imagewrap.classList.remove("is-transitioning");
          requestAnimationFrame(() => setTimeout(swapContent, DURATION));
        }
    };

    root.addEventListener("click", (e) => {
      const tab = e.target.closest(".tabbed-content-split__tab");
      if (!tab) return;
      e.preventDefault();
      e.stopPropagation();
      handleTabActivate(tab);
    });

    root.addEventListener("keydown", (e) => {
      const tab = e.target.closest(".tabbed-content-split__tab");
      if (!tab) return;
      if (e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      handleTabActivate(tab);
    });
  };

  const initAllSections = () => {
    document
      .querySelectorAll(".tabbed-content-split[data-section-id]")
      .forEach((section) => {
        initTabbedContent(section);
      });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(
      ".tabbed-content-split[data-section-id]"
    );
    if (section) {
      initTabbedContent(section);
    }
  });
})();
